<template>
  <div v-if="shouldDisplayFlexMessage">
    <p>
      <strong
        v-if="header.length"
        :style="strongStyles"
      >{{ header }}</strong> <span v-if="subheader.length">{{ subheader }}</span>
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FlexMessage',
  props: {
    header: {
      type: String,
      default: null
    },
    subheader: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState([
      'primaryColor'
    ]),
    shouldDisplayFlexMessage() {
      return (!!this.header && !!this.header.length) || (!!this.subheader && !!this.subheader.length);
    },
    strongStyles() {
      return {
        backgroundColor: this.primaryColor
      };
    }
  }
}
</script>

<style lang="scss">
#core-availability {
  .flex-message {
    p {
      font-size: $font-size-12px;

      strong {
        font-weight: bold;
        background-color: $primary;
        color: $white;
        padding: 0.15rem 0.25rem;
      }
    }
  }
}
</style>
